import React from 'react';

import { IconProps } from './types';

const EmptyListIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="300"
      height="245"
      viewBox="0 0 300 245"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M198.468 14.8281H50.149C49.035 14.8281 48.1318 15.7312 48.1318 16.8453V217.664C48.1318 218.778 49.035 219.681 50.149 219.681H198.468C199.582 219.681 200.485 218.778 200.485 217.664V16.8453C200.485 15.7312 199.582 14.8281 198.468 14.8281Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M214.375 1.125H66.0562C64.9422 1.125 64.0391 2.02811 64.0391 3.14216V203.961C64.0391 205.075 64.9422 205.978 66.0562 205.978H214.375C215.489 205.978 216.392 205.075 216.392 203.961V3.14216C216.392 2.02811 215.489 1.125 214.375 1.125Z"
        fill="white"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.3546 43.7461H159.253C159.68 43.7461 160.025 44.0919 160.025 44.5184V57.5478C160.025 57.9743 159.68 58.3201 159.253 58.3201H84.3546C83.9281 58.3201 83.5823 57.9743 83.5823 57.5478V44.5184C83.5823 44.0919 83.9281 43.7461 84.3546 43.7461Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.3263 79.3203H196.49C196.917 79.3203 197.263 79.6661 197.263 80.0926V93.122C197.263 93.5486 196.917 93.8943 196.49 93.8943H84.3263C83.8998 93.8943 83.554 93.5486 83.554 93.122V80.0926C83.554 79.6661 83.8998 79.3203 84.3263 79.3203Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M234.386 166.601L226.243 174.168L242.6 191.77L250.743 184.204L234.386 166.601Z"
        fill="#E8E8E8"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M245.015 178.658L237.488 185.652L242.386 190.923L249.913 183.929L245.015 178.658Z"
        fill="#E8E8E8"
      />
      <path
        d="M225.435 167.332L225.435 167.332C244.964 149.184 246.087 118.647 227.951 99.1218L227.951 99.1218C209.804 79.5927 179.262 78.4812 159.737 96.6172L159.737 96.6173C140.208 114.765 139.085 145.302 157.233 164.831L157.233 164.831C175.384 184.349 205.91 185.468 225.435 167.332ZM153.107 89.4782C176.576 67.6681 213.28 69.0217 235.09 92.4914C256.9 115.961 255.547 152.665 232.077 174.475C208.608 196.285 171.904 194.931 150.094 171.462C128.284 147.992 129.637 111.288 153.107 89.4782Z"
        fill="#545454"
        stroke="#12183E"
        strokeWidth="0.89375"
      />
      <path
        d="M228.577 166.568C209.233 184.537 178.99 183.428 161.006 164.091C143.027 144.743 144.139 114.488 163.488 96.5086C182.832 78.5405 213.091 79.6417 231.07 98.99C249.038 118.334 247.926 148.589 228.577 166.568Z"
        fill="white"
        fillOpacity="0.9"
      />
      <path
        d="M238.865 91.7497C216.887 68.0992 179.9 66.7351 156.25 88.7133C132.6 110.692 131.235 147.678 153.214 171.328C175.192 194.979 212.178 196.343 235.829 174.365C259.479 152.386 260.843 115.4 238.865 91.7497ZM228.579 166.567C209.234 184.535 178.991 183.426 161.007 164.09C143.028 144.741 144.141 114.487 163.489 96.5071C182.833 78.539 213.092 79.6402 231.071 98.9885C249.039 118.333 247.927 148.588 228.579 166.567Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="234.383"
        y="195.52"
        width="28.0046"
        height="66.5916"
        rx="7.97111"
        transform="rotate(-42.4138 234.383 195.52)"
        fill="white"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.623 115.518L211.452 107.346C211.052 106.947 210.435 106.947 210.035 107.346L195.672 121.71L181.799 107.837C181.145 107.183 180.074 107.183 179.42 107.837L171.285 115.972C170.885 116.371 170.885 117.007 171.285 117.406L185.648 131.77L171.176 146.242C170.849 146.569 170.849 147.096 171.176 147.423L180.128 156.375C180.4 156.647 180.836 156.647 181.127 156.375L195.708 141.794L209.908 155.994C210.38 156.466 211.161 156.466 211.652 155.994L220.168 147.477C220.531 147.114 220.531 146.551 220.168 146.188L205.732 131.752L219.66 117.824C220.295 117.189 220.295 116.153 219.66 115.518H219.623Z"
        fill="#FF6E55"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeMiterlimit="10"
      />
      <path
        d="M234.414 63.4297H291.311"
        stroke="#12183E"
        strokeWidth="0.89375"
        strokeLinejoin="round"
      />
      <path d="M0 129.113H31.9055" stroke="#12183E" strokeWidth="0.89375" strokeLinejoin="round" />
    </svg>
  );
};

export default EmptyListIcon;
